import { render, staticRenderFns } from "./CajasVentasDetails.vue?vue&type=template&id=1750efa8&"
import script from "./CajasVentasDetails.vue?vue&type=script&lang=js&"
export * from "./CajasVentasDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports